export default __webpack_public_path__ + "static/Plots0020-cecf090d1524f73e198fad4b51650b41.jpg";